/**
 * OrbDocCoreConceptsStandardLibraryENDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsStandardLibraryENDocScreen
 */

import { useOrbDocCoreConceptsStandardLibraryENDocScreenLogic } from '@/hooks/traits/useOrbDocCoreConceptsStandardLibraryENDocScreenLogic';
import type { OrbDocCoreConceptsStandardLibraryENDocScreenConfig } from '@/hooks/traits/useOrbDocCoreConceptsStandardLibraryENDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsStandardLibraryENDocView as OrbDocCoreConceptsStandardLibraryENDocViewEntity } from '@app/shared';
import { OrbDocCoreConceptsStandardLibraryENDocBodyView } from '@/components/traits/OrbDocCoreConceptsStandardLibraryENDocBodyView';
import { OrbDocCoreConceptsStandardLibraryENDocFooterView } from '@/components/traits/OrbDocCoreConceptsStandardLibraryENDocFooterView';
import { OrbDocCoreConceptsStandardLibraryENDocHeaderView } from '@/components/traits/OrbDocCoreConceptsStandardLibraryENDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsStandardLibraryENDocScreenViewProps {
  config?: Partial<OrbDocCoreConceptsStandardLibraryENDocScreenConfig>;
}

export function OrbDocCoreConceptsStandardLibraryENDocScreenView({ config: propsConfig }: OrbDocCoreConceptsStandardLibraryENDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsStandardLibraryENDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsStandardLibraryENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsStandardLibraryEN" trait="OrbDocCoreConceptsStandardLibraryENDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocCoreConceptsStandardLibraryENDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocCoreConceptsStandardLibraryENDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsStandardLibraryENDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsStandardLibraryENDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsStandardLibraryENDocScreenView;
